import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'

const BaseDatasetsEditView = Backbone.View.extend({

	FormViewClass: FormView,

	initialize: function(options) {
		this.options = options || {}
		// a record of the model before any changes
		this.originalModel = options.model

		// #16344 this.render can be called more than once, so must create the
		// FormView in the initialize method and not in render so multiple
		// FormViews aren't created
		this.createFormView()
	},

	createFormView: function() {
		this.formView = new this.FormViewClass({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	/**
	 * Returns the permissions directly associated with this view or dataset
	 * (as opposed to all permissions associated with the rootDataset)
	 */
	ownPermissions: function() {
		return _.filter(this.model.get('permissions'),
			permission => permission.datasetId == this.model.id)
	},

	/**
	 * Returns true if saving the view would result in switching from advanced
	 * permissions to standard permissions
	 */
	isRemovingAdvancedPermissions: function(permissions = []) {
		return !this.model.isNew() &&
			// permissions are manged at a higher level, must not show prompt
			!this.permissionElsewhere &&
			// Switching from advanced permissions...
			!_.isEmpty(this.ownPermissions()) &&
			// ... to standard permissions on the new data about to be saved
			_.isEmpty(permissions)
	},

	save: function(data) {
		var event = this.model.isNew() ? 'add' : 'edit'

		if (this.isRemovingAdvancedPermissions(data.permissions)) {
			const prompt = new ConfirmPrompt({
				confirmLabel: 'common.save',
				cancelLabel: 'common.cancel',
				titleKey: 'datasets.permissions.confirm.title',
				message: i18n.get('datasets.permissions.confirm.message',
					_.lowerCase(this.model.getTypeDescription())),
				onConfirm: () => this._saveModel(data, event)
			})
			prompt.once('cancel', () => this.formView.resetForm())
			appDisplay.dialog(prompt)
		} else {
			return this._saveModel(data, event)
		}
	}
})

export default BaseDatasetsEditView
BaseDatasetsEditView.__filename__ = 'datasets/edit/base-datasets-edit-view.js'
